import { TStoreData } from '@/interface';

const defaultUserMenu: TStoreData = {
    layoutMode: localStorage.getItem('matchRouterPr') || 'lr', // 大屏小屏
    user: {}, // 用户信息
    flow: [], // 流程
    other: [], // 其他流程
    subMenuList: [], // 二级子菜单 大屏模式会用到
    subApp: [], // 子应用信息
    subAppMap: {}, // 子应用信息 map 枚举类型
    flowAndOtherActive: '',
    quickEntrance: [], // 快捷入口
    customRecord: {}, // 用户收藏喜好的记录
    eventTracking: {}, // 埋点数据
    userProcess: [],
    orgTree: {}, // 组织树
    orgActive: {}, // 选中的组织
    tenantCode: '',
    childMenu: {},
    //一级租户列表
    tenantList: [],
    //当前一级租户信息
    firstTenant: {},
};

const StoreMain = (state = defaultUserMenu, action: any) => {
    switch (action.type) {
        case 'setUserInfo':
            return {
                ...state,
                user: action.value,
            };
        case 'setFlow':
            return {
                ...state,
                flow: action.value,
            };
        case 'setOtherMenu':
            return {
                ...state,
                other: action.value,
            };
        case 'setSubMenuList':
            return {
                ...state,
                subMenuList: action.value,
            };
        case 'setChildMenu':
            return {
                ...state,
                childMenu: action.value,
            };
        case 'setLayoutMode':
            localStorage.setItem('matchRouterPr', action.value);
            return {
                ...state,
                layoutMode: action.value,
            };
        case 'setSubAppList':
            return {
                ...state,
                subApp: action.value,
            };

        case 'setSubAppMap':
            return {
                ...state,
                subAppMap: action.value,
            };

        case 'setFlowAndOtherActive':
            return {
                ...state,
                flowAndOtherActive: action.value,
            };
        case 'setQuickEntrance':
            return {
                ...state,
                quickEntrance: action.value,
            };
        case 'setCustomRecord':
            return {
                ...state,
                customRecord: action.value,
            };
        case 'setEventTracking':
            return {
                ...state,
                eventTracking: action.value,
            };
        case 'setUserProcess':
            return {
                ...state,
                userProcess: action.value,
            };

        case 'setOrgTree':
            return {
                ...state,
                orgTree: action.value,
            };
        case 'setOrgActive':
            localStorage.setItem('selectOrgInfo', JSON.stringify(action.value));
            return {
                ...state,
                orgActive: action.value,
            };
        case 'setTenantList':
            return {
                ...state,
                tenantList: action.value,
            };
        case 'setFirstTenant':
            return {
                ...state,
                firstTenant: action.value,
            };
        default:
            return state;
    }
};

export default StoreMain;
